import React, { useEffect } from 'react';
import { docs_legal } from '../../constants';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const privacyData = docs_legal.find(doc => doc.title === 'Privacy Policy');

  useEffect(() => {
    document.body.classList.add('darkMode');
    document.body.classList.add('dark');
  }, []);

  return (
    <div className='legal_container'>
      <div className="legal_header">
        <h1 className='legal_title'>
          {privacyData?.title}
        </h1>
        <p className="legal_subtitle">
          Your privacy is important to us. Learn how we protect your data.
        </p>
      </div>
      
      <div className='legal_content'>
        <div className="legal_section">
          <div className="legal_text">
            {privacyData?.text}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
